import InputField from "@ingka/input-field";
import { useEffect, useState } from "react";
import FormField from "@ingka/form-field";
import Label from "@ingka/label";
import LabelWithToolTip from "../LabelWithTooltip/LabelWithToolTip";

type Props = {
  id: string;
  labelText: string;
  toolTipText?: string;
  initialValue?: string;
  disabled?: boolean;
  shoudlValidate?: boolean;
  errorMessage?: string;
  onBlur?: (value: string) => void;
  onChange?: (value: string) => void;
};

const InputTextField = ({
  id,
  labelText,
  toolTipText,
  initialValue,
  disabled,
  shoudlValidate,
  errorMessage,
  onBlur,
  onChange,
}: Props) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <FormField
      valid="error"
      validation={{
        msg: errorMessage,
        type: "error",
      }}
      shouldValidate={shoudlValidate}
    >
      <InputField
        id={id}
        label={
          <Label
            htmlFor={id}
            label={
              <LabelWithToolTip
                labelText={labelText}
                toolTipText={toolTipText}
              />
            }
          />
        }
        disabled={disabled}
        name={id}
        type="text"
        value={value}
        onChange={(e) => {
          const { value } = e.target;
          setValue(value);
          onChange && onChange(value);
        }}
        onBlur={() => onBlur && onBlur(value!)}
      />
    </FormField>
  );
};

export default InputTextField;
